import {peachpayUpdateCurrencyCookie} from '../../@shared/ts/currency';

const peachpayCurrencySwitcherWidget = document.querySelector<HTMLSelectElement>('#pp-currency-widget');
peachpayCurrencySwitcherWidget?.addEventListener('change', async event => {
	const {target} = event;
	peachpayUpdateCurrencyCookie((target as HTMLInputElement)?.value);

	await fetch('/?wc-ajax=pp-cart&only-calculate');
	window.location.reload();
});
